import { takeEvery, all, fork, put } from "redux-saga/effects";
import {
  GET_CALENDAR,
  ADMIN_BOOK_APPOINTMENT,
  EDIT_ADMIN_APPOINTMENT,
  CALL_CUSTOMERS_API,
} from "../constants/ActionTypes";
import admin from "../services/admin";
import * as actions from "../actions";
import _ from "lodash";
import moment from "moment";

function* getCalendar(action) {
  try {
    admin.defaults.headers.Authorization = `Bearer ${localStorage.getItem("token")}`;
    const response = yield admin.post(`/calendar`);
    const customers = yield admin.get("/customers");

    const employees = response.data.employees_working.filter(item => item.enabled !== false);

    response.data.employees_working = employees;

    const resources = response.data.employees_working.map(employee => {
      const { _id, firstname, lastname } = employee;

      return {
        resourceId: _id,
        resourceTitle: `${firstname} ${lastname}`,
      };
    });
    const events = response.data.employees_working.map(employee => {
      const event = employee.appointments.map(appointment => {
        const {
          _id,
          from,
          to,
          service,
          price,
          duration,
          status,
          customer,
          firstname,
          lastname,
          message,
          servicename,
        } = appointment;
        const tempService = service ? service._id : undefined;
        return {
          id: _id,
          title: `${servicename} - ${employee.firstname} ${employee.lastname}`,
          // for safari support comment this links
          // start: new Date(from),
          // end: new Date(to),
          start: moment(from)._d,
          end: moment(to)._d,
          resourceId: employee._id,
          price,
          duration,
          status,
          customer,
          firstname,
          lastname,
          message,
          servicename,
          serviceId: tempService,
        };
      });
      return event;
    });
    // const customersList = customers.data.map(customer => {
    //   const { primary_details } = customer;
    //   return {
    //     id: primary_details._id,
    //     firstname: primary_details.firstname,
    //     lastname: primary_details.lastname,
    //   };
    // });
    const events1 = _.union.apply(null, events);
    response.data.resources = resources;
    const selectedResources = resources.slice(0, 1);
    response.data.selectedResources = selectedResources;
    const selectedEmployees = employees.slice(0, 1);
    response.data.selectedEmployees = selectedEmployees;
    response.data.events = events1;
    const selectedEvents = events1.filter(item => item.resourceId === selectedEmployees[0]._id);
    response.data.selectedEvents = selectedEvents;

    yield put(actions.setCalendarData({ data: response.data, setCurrentDate: action.payload }));
    yield put(actions.setCustomerList(customers.data));
  } catch (error) {
    if (!error.response) {
      // yield put(actions.adminBookFailResponse(error.response.data.message));
    } else {
      yield put(actions.adminBookFailResponse(error.response.data.message));
    }
  }
}

function* adminBookAppointment(action) {
  //
  const userdata = JSON.parse(localStorage.getItem("user-data"));

  try {
    const response = yield admin.post("/appointments/", {
      from: action.payload.from,
      to: action.payload.to,
      status: "booked",
      employee: action.payload.employee,
      service: action.payload.service,
      duration: action.payload.duration,
      price: action.payload.price,
      customer: action.payload.customer,
      message: action.payload.message ? action.payload.message : "",
      location: localStorage.getItem("business_location"),
      businessname: userdata.business.name,
      business_slug: userdata.business.business_slug,
      remindersent: false,
    });

    // yield put(actions.setConfirmationPage(response.data));

    const { data } = response;
    const {
      firstname,
      lastname,
      _id: id,
      price,
      duration,
      message,
      service,
      status,
      employee,
      customer,
      servicename,
    } = data;

    let { from: start, to: end } = data;
    start = new Date(start);
    end = new Date(end);

    const { _id: serviceId } = service;
    const { _id: resourceId } = employee;
    const title = `${employee.firstname} ${employee.lastname} - ${servicename}`;
    const myObject = {
      firstname,
      lastname,
      id,
      price,
      duration,
      message,
      serviceId,
      resourceId,
      start,
      end,
      status,
      customer: customer._id,
      title,
      servicename,
    };

    yield put(actions.adminBookAppointmentResponse(myObject));
    yield put(actions.showAppointmentMessage("Appointment is Booked"));
    yield put(actions.toggleModal(false));
  } catch (error) {
    if (error.response.data.message == "Not Found") {
      yield put(
        actions.adminBookFailResponse(
          "This time slot is not available. Please select another time slot."
        )
      );
    } else {
      yield put(actions.adminBookFailResponse(error.response.data.message));
    }
  }
  yield put(actions.adminBookLoaderHide());
}

function* editAdminAppointment({ payload }) {
  //

  try {
    const response = yield admin.put(`/appointments/${payload.appointmentId}`, {
      from: payload.from,
      to: payload.to,
      status: payload.status,
      location: localStorage.getItem("business_location"),
      employee: payload.employee,
      change: payload.change,
      service_duration: payload.duration,
    });

    // yield put(actions.setConfirmationPage(response.data));
    const { data } = response;
    const {
      firstname,
      lastname,
      _id: id,
      price,
      duration,
      message,
      service,
      status,
      employee,
      customer,
      servicename,
    } = data;

    let { from: start, to: end } = data;
    start = new Date(start);
    end = new Date(end);

    let serviceId = "";
    let customerId = "";
    if (service) {
      serviceId = service._id;
    }
    if (customer) {
      customerId = customer._id;
    }
    const { _id: resourceId } = employee;
    const title = `${employee.firstname} ${employee.lastname} - ${servicename}`;
    const myObject = {
      firstname,
      lastname,
      id,
      price,
      duration,
      message,
      serviceId,
      resourceId,
      start,
      end,
      status,
      customer: customer,
      title,
      servicename,
    };
    const { appointmentId } = payload;

    yield put(actions.editAdminAppointmentResponse({ myObject, appointmentId }));
    yield put(actions.showAppointmentMessage("Appointment is Modified"));

    yield put(actions.toggleModal(false));
  } catch (error) {
    if (error.response.data.message == "Not Found") {
      yield put(
        actions.adminBookFailResponse(
          "This time slot is not available. Please select another time slot."
        )
      );
    } else {
      yield put(actions.adminBookFailResponse(error.response.data.message));
    }
  }
  yield put(actions.adminBookLoaderHide());
}

function* callCustomer() {
  try {
    const customers = yield admin.get("/customers");

    // const customersList = customers.data.map(customer => {
    //   const { primary_details } = customer;
    //   return {
    //     id: primary_details._id,
    //     firstname: primary_details.firstname,
    //     lastname: primary_details.lastname,
    //   };
    // });
    yield put(actions.callCustomerApiResponse(customers.data));
  } catch (error) {
    yield put(actions.adminBookFailResponse(error.response.data.message));
  }
}

export function* requestCalendar() {
  yield takeEvery(GET_CALENDAR, getCalendar);
}

export function* requestAppointment() {
  yield takeEvery(ADMIN_BOOK_APPOINTMENT, adminBookAppointment);
}

export function* editAppointment() {
  yield takeEvery(EDIT_ADMIN_APPOINTMENT, editAdminAppointment);
}

export default function* rootSaga() {
  yield all([
    fork(requestCalendar),
    fork(requestAppointment),
    fork(editAppointment),
    takeEvery(CALL_CUSTOMERS_API, callCustomer),
  ]);
}



// WEBPACK FOOTER //
// ./sagas/AdminBookAppointment.js